import * as jsxRuntime from "/Users/wangkang-cdfs/no_BB_show_code/cdfs/operation-activity/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment